import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from './axiosInstance'
import type { TemplateJson } from '../types/template'

interface TemplateSummary {
  name: string
  meta: TemplateJson['meta']
}

export function useTemplates() {
  return useQuery({
    queryKey: ['templates'],
    queryFn: async () => {
      const res = await api.get<TemplateSummary[]>('/templates')
      return res.data
    },
  })
}

export function useTemplate(name: string) {
  return useQuery({
    queryKey: ['templates', name],
    queryFn: async () => {
      const res = await api.get<TemplateJson>(`/templates/${name}`)
      return res.data
    },
    enabled: !!name,
  })
}

export function useDeleteTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (name: string) => {
      await api.delete(`/templates/${name}`)
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['templates'] }),
  })
}

export function useUploadTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ name, content }: { name: string; content: unknown }) => {
      await api.post('/templates', { name, content })
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['templates'] }),
  })
}
